import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../nodeInstance";
import { useNavigate } from "react-router-dom";
import { setAppError } from "../../../../store/userSlice";

export default function CancelPopUpInvoice({
  cancelPopUp,
  setCancelPopUp,
  propData,
  contractId,
}) {
  console.log("Data to be printed here....seccccc", propData, contractId);
  const [loading, setLoading] = useState(false);
  const hanldeClose = () => {
    setCancelPopUp(false);
  };
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const navigate = useNavigate();
  const [comments, setComments] = useState("");
  const handleCommentsChange = (e) => {
    setComments(e.target.value);
  };
  const OnSubmit = async () => {
    if (comments === "") {
      dispatch(
        setAppError({
          msg: "Cancelation comments are required.",
        })
      );
      return;
    }
    const mappedData = propData.map((data) => {
      return {
        employee_id: data.employee_id,
        invoice_no: data.invoice_no,
        Cancel_comments: comments,
      };
    });
    const reqObject = {
      mappedData,
    };

    try {
      const response = await nodeinstance.put(
        `/dashboard/visaSecOnArrival/cancelInvoice`,
        reqObject,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        console.log("Data to be seen here in console...");
        setCancelPopUp(false);
        navigate("/dashboard/visa-cost-&-sec-deposit/summary-OnArrival");
      }
    } catch (error) {
      console.log("error to be seen here...", error);
    }
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          cancelPopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <>
            <h2 className="m-2">{`Do you want to cancel the Invoice`}</h2>
            <div className="flex flex-col p-2 gap-1 w-full max-w-md">
              <label htmlFor={`addOrEdit-name`} className="text-xs ">
                Enter your comments below
              </label>
              <input
                className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                value={comments}
                onChange={(e) => {
                  handleCommentsChange(e);
                }}
              />
            </div>

            <div className="flex gap-3 w-full justify-center" style={{ m: 2 }}>
              <button
                className="p-2 bg-blue text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                onClick={() => {
                  hanldeClose();
                }}
              >
                {" "}
                <p>CANCEL</p>
              </button>

              <button
                className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                onClick={() => {
                  OnSubmit();
                }}
              >
                {" "}
                <p>Submit</p>
                {loading ? <CgSpinner className="animate-spin" /> : ""}
              </button>
            </div>
          </>
        </div>
      </div>
    </>
  );
}
